<template>
  <div>
    <img
      class="titleimg"
      src="/static/imgs/shouye6.png"
      style="width: 100%; height: 150px ;object-fit: cover;"
    />
    <div class="box">
      <el-row :span="24">
        <el-col
          :span="8"
          :offset="4"
          class="guanyu"
          :xs="{ span: 22, offset: 1 }"
          ><img src="/static/imgs/guanyuwomen.png" alt=""
        /></el-col>
        <el-col :span="16" :offset="4" :xs="{ span: 22, offset: 1 }">
          <p class="title">石家庄易通达网络技术有限公司</p>
          <p class="introduce">
            石家庄易通达网络技术有限公司成立于2013年1月，位于石家庄市高新区科技中心，是一家专业化的高新科技企业，致力于核心工业控制器的研发与生产，优势产品为以PLC系列模组为核心的智能化ACU本地控制器、智能设备机箱与机房环境主机等，广泛应用于公路隧道、市区管廊和其它工业控制现场。公司提供从现场控制设备到监控中心配套软件平台的整体解决方案。
          </p>
          <p class="introduce">
            公司拥有高新技术企业、软件企业、国家级科技中小企业认证。具有信息系统建设与服务能力等级证书，并通过了ISO质量管理、环境管理、职业健康安全管理三体系认证。拥有经验丰富的软硬件专业技术人员、项目经理、管理及销售团队，支持企业持续、快速、健康发展。
          </p>
          <p class="introduce">
            公司充分融合物联网、大数据、移动互联、边缘计算等前沿技术，将新一代智能工业控制技术应用作为主要研发方向。
          </p>
        </el-col>
        <el-col :span="16" :offset="4" :xs="{ span: 22, offset: 1 }">
          <el-row :span="24" class="imgs" type="flex" justify="space-between">
            <el-col :span="7" :xs="{ span: 24 }"
              ><img src="/static/imgs/img1.png" alt=""
            /></el-col>
            <el-col :span="7" :xs="{ span: 24 }"
              ><img src="/static/imgs/img2.png" alt=""
            /></el-col>
            <el-col :span="7" :xs="{ span: 24 }"
              ><img src="/static/imgs/img3.png" alt=""
            /></el-col>
          </el-row>
        </el-col>
        <el-col
          :span="8"
          :offset="4"
          class="guanyu renzheng"
          :xs="{ span: 22, offset: 1 }"
          ><img src="/static/imgs/img7.png" alt=""
        /></el-col>
        <el-col :span="16" :offset="4" :xs="{ span: 22, offset: 1 }">
          <el-row
            :span="24"
            class=""
            type="flex"
            justify="space-between"
          >
          <el-col :span="5" :xs="{ span: 24 }">
              <img src="/static/imgs/img20.png" alt="" style="height: 200px"
            /></el-col>
            <el-col :span="5" :xs="{ span: 24 }">
              <img src="/static/imgs/img16.png" alt="" style="height: 200px"
            /></el-col>
            <!-- <el-col :span="4" :xs="{ span: 24 }">
              <img src="/static/imgs/img17.png" alt="" style="height: 200px"
            /></el-col> -->
            <el-col :span="5" :xs="{ span: 24 }">
              <img src="/static/imgs/img18.png" alt="" style="height: 200px"
            /></el-col>
            <el-col :span="5" :xs="{ span: 24 }">
              <img src="/static/imgs/img19.png" alt="" style="height: 200px"
            /></el-col>
       
             </el-row
        ></el-col>
        <el-col :span="16" :offset="4" :xs="{ span: 22, offset: 1 }">
          <el-row
            :span="24"
            class=""
            type="flex"
            justify="space-between"
          >
            <el-col :span="6" :xs="{ span: 24 }">
              <img src="/static/imgs/img4.png" alt=""
            /></el-col>
            <el-col :span="6" :xs="{ span: 24 }">
              <img src="/static/imgs/img5.png" alt=""
            /></el-col>
            <el-col :span="6" :xs="{ span: 24 }">
              <img src="/static/imgs/img6.png" alt=""
            /></el-col>
          </el-row>
        </el-col>
        <el-col :span="16" :offset="4">
          <el-row class="renzheng2" type="flex" justify="space-between">
            <el-col :span="5" :xs="{ span: 24 }"
              ><img src="/static/imgs/img8.png" alt=""
            /></el-col>
            <el-col :span="5" :xs="{ span: 24 }"
              ><img src="/static/imgs/img9.png" alt=""
            /></el-col>
            <el-col :span="5" :xs="{ span: 24 }"
              ><img src="/static/imgs/img10.png" alt=""
            /></el-col>
            <el-col :span="5" :xs="{ span: 24 }"
              ><img src="/static/imgs/img11.png" alt=""
            /></el-col>
          </el-row>
        </el-col>
        <el-col class="zizhi hidden-xs-only" :span="16" :offset="4"
          ><img src="/static/imgs/img12.png" alt=""
        /></el-col>
        <el-col class="zizhi hidden-xs-only" :span="16" :offset="4"
          ><img src="/static/imgs/img13.png" alt=""
        /></el-col>
        <el-col
          :span="8"
          :offset="4"
          class="guanyu lianxi"
          :xs="{ span: 22, offset: 1 }"
          ><img src="/static/imgs/img14.png" alt=""
        /></el-col>
        <el-col
          :span="16"
          :offset="4"
          :xs="{ span: 24, offset: 0 }"
          class="map"
        >
          <!-- <img src="/static/imgs/img15.png" alt=""
        /> -->
          <!-- <iframe src="@/src/components/map.html"  frameborder="0"  width="100%"  height="100%"></iframe> -->
          <iframe
            src="/static/map.html"
            frameborder="0"
            width="100%"
            height="100%"
          ></iframe>
        </el-col>
        <el-col :span="16" :offset="4" :xs="{ span: 22, offset: 1 }">
          <el-row
            :span="24"
            type="flex"
            justify="space-between"
            class="contact"
          >
            <el-col :span="6" :xs="{ span: 24 }" class="left">
              <p class="title">地址</p>

              <p>河北省石家庄市高新区</p>

              <p>祁连街95号润江慧谷大厦B座</p>
            </el-col>
            <el-col :span="6" :xs="{ span: 24 }" class="right">
              <p class="title">联系电话</p>
              <!-- <p>公司电话 : 0311-66690272</p>
              <p>综合办电话 : 0311-66690210</p>
              <p>市场电话 : 0311-87243465</p> -->
              <p><i class="el-icon-mobile-phone"></i>13722868077</p>
              <p><i class="el-icon-phone"></i>0311-87243465</p>
           
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  components: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {
    $route: {
      handler(newval) {
        // document.documentElement.scrollTop = 1000
        if (!newval.query.item) return;
        this.$nextTick(() => {
          let a = document.querySelector("." + newval.query.item).offsetTop;
          console.log(document.querySelector('.'+newval.query.item).offsetTop);
          document.documentElement.scrollTop = a;
        });
        console.log(newval.query.item);
      },
      immediate: true,
    },
  },
  methods: {},
  beforeDestroy() {},
};
</script>

<style scoped lang="less">
@media screen and(max-width:700px) {
  // *{
  //   font-size: 50px !important;
  // }
  .box {
    img {
      height: auto !important;
      object-fit: cover !important;
    }
  }
  .titleimg {
    height: auto !important;
  }
  .imgs {
    display: block;
    div {
      margin-top: 20px;
    }
  }
  .renzheng {
    display: block;
  }
  .renzheng2 {
    display: block;
  }
  .zizhi {
    height: 150px;
    img {
      height: 100% !important;
    }
  }
  .contact {
    display: block;
    .left {
      display: none;
    }
    .right {

      p {
        text-align: left !important;
      }
    }
  }
}
.box {
  .contact {
    margin-bottom: 80px;
    .left {
      p {
        height: 30px;
        line-height: 30px;
        text-align: left;
        margin-bottom: 0;
      }
    }
    .right {
      p {
        height: 30px;
        line-height: 30px;
        text-align: right;
        margin-bottom: 0;
      }
      P:nth-child(2){
      letter-spacing:3px;
    }
    P:nth-child(3){
      letter-spacing:1px;
    }
    }
    .title {
      color: #1555d0;
      font-size: 20px;
      font-weight: 700;
      font-family: "Microsoft YaHei";
      height: 60px !important;
      line-height: 60px !important;
    }
    p {
      color: #000000e6;
      font-size: 20px;
      font-weight: 400;
      font-family: "Microsoft YaHei";
    }

    i{
      color: #1555d0;
      margin-right: 10px;
    }
  }
  img {
    width: 100%;
    height: 360px;
    object-fit: scale-down;
  }
  width: 100%;
  .guanyu {
    margin-top: 40px;
    img {
      width: auto;
      height: auto;
    }
  }
  .title {
    color: #1555d0;
    font-size: 32px;
    font-weight: 700;
    font-family: "Microsoft YaHei";
    text-align: center;
    margin-bottom: 24px;
  }
  .introduce {
    text-indent: 2em;
    text-align: justify;
    color: #727272;
    font-size: 20px;
    font-weight: 400;
    font-family: "Microsoft YaHei";
    line-height: 40px;
  }
  .imgs {
    margin-top: 40px;
    overflow: hidden;
    img {
      width: 100%;
      object-fit: scale-down;
    }
  }
  .map {
    height: 360px;
    margin-top: 40px;
    iframe {
      overflow: hidden;
    }
  }
}
</style>
